"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumnSchema = exports.TableColumnCategorySchema = exports.TableColumnCategoryKeySchema = void 0;
const zod_1 = require("zod");
exports.TableColumnCategoryKeySchema = zod_1.z.enum([
    'event',
    'competition',
    'season',
    'team',
    'player',
    'recipient_player',
    'game',
    'player_metric',
    'player_total_metric',
    'team_metric',
    'team_total_metric',
    'game_state',
    'goalkeeping',
    'in_possession',
    'out_of_possession',
    'passing',
    'set_piece',
    'shooting',
    'spatial',
    'goalkeeping_player_metric',
    'in_possession_player_metric',
    'obv_player_metric',
    'out_of_possession_player_metric',
    'passing_player_metric',
    'set_piece_player_metric',
    'shooting_player_metric',
    'goalkeeping_player_total_metric',
    'in_possession_player_total_metric',
    'obv_player_total_metric',
    'out_of_possession_player_total_metric',
    'passing_player_total_metric',
    'set_piece_player_total_metric',
    'shooting_player_total_metric',
    'player_player_metric',
    'player_player_total_metric',
    'team_team_metric',
    'team_team_total_metric',
    'goalkeeping_team_metric',
    'goalkeeping_team_total_metric',
    'in_possession_team_metric',
    'in_possession_team_total_metric',
    'obv_team_metric',
    'obv_team_total_metric',
    'opposition_team_metric',
    'opposition_team_total_metric',
    'out_of_possession_team_metric',
    'out_of_possession_team_total_metric',
    'passing_team_metric',
    'passing_team_total_metric',
    'set_piece_team_metric',
    'set_piece_team_total_metric',
    'shooting_team_metric',
    'shooting_team_total_metric',
    'obv',
]);
exports.TableColumnCategorySchema = zod_1.z.object({
    key: exports.TableColumnCategoryKeySchema,
    parent_category_key: exports.TableColumnCategoryKeySchema.nullable(),
    name: zod_1.z.string(),
});
exports.TableColumnSchema = zod_1.z.object({
    table_column: zod_1.z.object({
        key: zod_1.z.string(),
        format_rule: zod_1.z.string(),
    }),
    category_leaf: exports.TableColumnCategorySchema,
    category_branch: exports.TableColumnCategorySchema,
});
//# sourceMappingURL=tableColumn.js.map